import { useAuth } from "oidc-react";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useSearchParams } from "react-router-dom";
import AuthWrapper from "../../components/auth/AuthWrapper";
import Button from "../../components/ui/Button";
import { SpinLoader } from "../../components/ui/SpinLoader";
import useWindowSize from "../../hooks/useWindowResize";
import { popupCenter } from "../../utils/auth/loginPopup";

const clearStaleOidcState = () => {
  Object.keys(localStorage)
    .filter((k) => k.startsWith("oidc."))
    .forEach((k) => localStorage.removeItem(k));
};

const Login = () => {
  const [logginIn, setLogginIn] = useState<boolean>(false);
  const { signIn } = useAuth();
  const { sm, md } = useWindowSize();
  const [searchParams] = useSearchParams();
  const isPopup = searchParams.get("popup") === "1";

  useEffect(() => {
    if (!isPopup) return;
    clearStaleOidcState();
    signIn({ prompt: "login" }).catch(() => {
      toast.error("Logimi deshtoi. Mbyllni kete dritare dhe provoni perseri.");
    });
  }, [isPopup]);

  const logIn = async () => {
    if (logginIn) return;
    setLogginIn(true);

    const isMobile = sm || md;

    if (!isMobile) {
      const popup = popupCenter("/login?popup=1", "Log in");
      if (popup) return;
    }

    clearStaleOidcState();

    const stuckTimer = window.setTimeout(() => {
      setLogginIn(false);
      toast.error(
        "Ridrejtimi nuk u krye. Kontrolloni lidhjen dhe provoni perseri."
      );
    }, 8000);

    try {
      await signIn({ prompt: "login" });
    } catch {
      window.clearTimeout(stuckTimer);
      setLogginIn(false);
      toast.error("Logimi deshtoi. Provoni perseri.");
    }
  };

  if (isPopup) {
    return (
      <div className="flex justify-center items-center w-full h-screen">
        <SpinLoader formatClassName="h-8 w-8" />
      </div>
    );
  }

  return (
    <div className="flex flex-col justify-between p-10">
      <img src="logo.svg" className="w-36" />
      <AuthWrapper
        heading={
          <span>
            Planifiko udhëtimin
            <br /> e ardhshëm!
          </span>
        }
        paragraph="Zbuloni mundësitë tuaja të udhëtimit me ne!"
        span=""
        linkContent=""
        linkTo=""
      >
        <Button padding="px-11 py-3" className="flex" onClick={logIn}>
          {logginIn ? (
            <>
              Redirecting to Porta
              <SpinLoader className="ml-2" formatClassName="h-4 w-4" />
            </>
          ) : (
            "Vazhdo Kyçu"
          )}
        </Button>
      </AuthWrapper>
      <div className="text-gray gap-6 text-sm flex">
        <a href="#">Rreth nesh</a>
        <a href="#">Privatësia</a>
        <a href="#">Ndihmë</a>
      </div>
    </div>
  );
};

export default Login;
